import strings from 'l10n'
import { MenuBarListItem } from './MenuBar'

export const footerMenuBar: MenuBarListItem[] = [
  {
    name: strings.PROFILE,
    icon: 'menubar/icon_settings',
    id: 'profile',
  },
]
